<forge-list dense (keyup)="onKeyUp($event)" class="nav-menu-context">
    <ng-container *ngFor="let item of contextItems">
        <forge-list-item>
            <button #item autofocus type="button" (click)="onClick($event, item)">
                {{item.label}}
            </button>
        </forge-list-item>
    </ng-container>
</forge-list>